import React, { useState } from 'react'
import Popup, { PopupTypeEnum } from '../../../components/popup/Popup'
import { useCreateTaskObjectMutation } from '../../../core/api/TaskApi'
import {
  AppNotification,
  NotificationType,
} from '../../../components/notification/Notification'
import { useTranslation } from 'react-i18next'
import {
  mapComplianceToLabel,
  formatAiPredictions,
} from 'utils/complianceHelpers'
import { ZoomIcon } from 'pages/DishesPage/components/ZoomIcon'

interface IReportImageUpscaleProps {
  photo?: string | null
  isDimension?: boolean
  isCategory?: boolean
  isFact?: boolean
  hasFact?: boolean
  dimensionId?: number | null
  temperature?: number | string | null
  standardTempMax?: number | null
  standardTempMin?: number | null
  onZoomClick?: () => void
  showTags?: boolean
  complianceWithStandards?: string
  aiPredictions?: string[]
}

export const ReportImageUpscale = (props: IReportImageUpscaleProps) => {
  const { t } = useTranslation()
  const {
    photo,
    isDimension,
    isCategory,
    dimensionId,
    isFact,
    hasFact,
    temperature,
    standardTempMax,
    standardTempMin,
    onZoomClick,
    showTags = false,
    complianceWithStandards,
    aiPredictions,
  } = props
  const [isZoomPhoto, setIsZoomPhoto] = useState(false)
  const onZoomToggle = () => setIsZoomPhoto((state) => !state)
  const handleZoomClick = onZoomClick || onZoomToggle
  const { label: complianceLabel, className: complianceClass } =
    mapComplianceToLabel(complianceWithStandards)

  const aiPredictionsText = formatAiPredictions({ aiPredictions })

  if (!photo) {
    const notFoundClass =
      !isFact && hasFact
        ? 'report-image-upscale__container'
        : 'not-found-photo-block'

    if (isDimension && isCategory) return null

    return (
      <div className={notFoundClass}>
        <div className={!isFact && hasFact ? 'heading' : 'title'}>
          {isFact
            ? temperature !== null &&
              temperature !== undefined &&
              temperature !== ''
              ? `${t('Факт')} ${temperature}°C`
              : `${t('Факт')}`
            : `${t('Эталон')} ${
                !!(
                  (standardTempMax || standardTempMax === 0) &&
                  (standardTempMin || standardTempMin === 0)
                )
                  ? `${standardTempMin}-${standardTempMax}°C`
                  : ''
              }`}
        </div>
        {isFact && showTags && (
          <div className="subtitle">
            <span className={`tag ${complianceClass}`}>{complianceLabel}</span>
            {aiPredictionsText && <span>{aiPredictionsText}</span>}
          </div>
        )}
        <div className="report-image-popup__photos-notfound">
          <i className="an-ico an-ico-photo-add" />
        </div>
        {/*<AddTaskBtn id={dimensionId} />*/}
      </div>
    )
  }
  return (
    <div className={'report-image-upscale__container'}>
      <div className="heading">
        <div className="title">
          {isFact
            ? temperature !== null &&
              temperature !== undefined &&
              temperature !== ''
              ? `${t('Факт')} ${temperature}°C`
              : `${t('Факт')}`
            : `${t('Эталон')} ${
                !!(
                  (standardTempMax || standardTempMax === 0) &&
                  (standardTempMin || standardTempMin === 0)
                )
                  ? `${standardTempMin}-${standardTempMax}°C`
                  : ''
              }`}
        </div>
        {isFact && showTags && (
          <div className="subtitle">
            <span className={`tag ${complianceClass}`}>{complianceLabel}</span>
            {aiPredictionsText && <span>{aiPredictionsText}</span>}
          </div>
        )}
      </div>

      <img src={photo} alt="" loading="lazy" />
      <div
        className="zoom-icon"
        role="button"
        aria-label="zoom"
        onClick={(e) => {
          e.stopPropagation()
          handleZoomClick()
        }}
      >
        <ZoomIcon />
      </div>
      {isZoomPhoto && (
        <Popup popupType={PopupTypeEnum.photo} closePopup={onZoomToggle}>
          <img
            src={photo}
            alt=""
            className="img-child-popup"
            loading="lazy"
            style={{ cursor: 'pointer' }}
            onClick={onZoomToggle}
          />
        </Popup>
      )}
      {/* {isDimension && <AddTaskBtn id={dimensionId} />} */}
    </div>
  )
}

interface AddTaskBtnProps {
  id?: number | null
}

const AddTaskBtn = ({ id }: AddTaskBtnProps) => {
  const { t } = useTranslation()
  const [createTaskObject] = useCreateTaskObjectMutation()

  const onAddTaskObjectClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    if (id) {
      createTaskObject({ orderLineDimension: id })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Объект успешно добавлен'),
            type: NotificationType.success,
          })
        })
    }
  }
  return (
    <div className="add-task-block" onClick={onAddTaskObjectClick}>
      <i className="an-ico an-ico-add" />
    </div>
  )
}
